<template>
	<article class="event-review">
		<managing-section>
			<managing-box title="이벤트 선택">
				<div class="event-review__search-event">
					<select
						class="select event-review__search-event__selector"
						v-model="year"
					>
						<option
							v-for="year in yearList"
							:key="year"
							:value="year === yearFirstValue ? null : year"
						>
							{{ year }}
						</option>
					</select>
					<select
						class="select event-review__search-event__selector"
						v-model="month"
					>
						<option
							v-for="month in monthList"
							:key="month"
							:value="month === monthFirstValue ? null : month"
						>
							{{ month }}
						</option>
					</select>
					<button
						class="btn blue event-review__search-event-btn"
						type="button"
						@click="searchEvent"
					>
						검색
					</button>
					<button
						class="btn-excel event-review__event-excel-btn"
						type="button"
						v-if="hasEventList"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
				<ul class="event-review__event-list" v-if="hasEventList">
					<li
						v-for="event in parsedEventList"
						:key="event.originData.idAdminBoard"
					>
						<button
							:class="
								event.selected
									? 'event-review__event-list__btn--selected'
									: 'event-review__event-list__btn'
							"
							type="button"
							@click="selectEvent(event.originData.idAdminBoard)"
						>
							<span
								class="event-review__event-list__btn__title"
								>{{ event.title }}</span
							>
							<span
								class="event-review__event-list__btn__period"
								>{{ event.period }}</span
							>
						</button>
					</li>
				</ul>
			</managing-box>
			<managing-box title="상품 선택">
				<p class="event-review__select-product__title">
					{{ event ? event.boardTitle : '이벤트를 선택해주세요' }}
				</p>
				<select
					class="select"
					v-model="idProduct"
					@change="changeProduct"
				>
					<option
						v-for="product in getProductList"
						:key="product.idProduct"
						:value="product.idProduct"
					>
						{{ product.productTitle }}
					</option>
				</select>
			</managing-box>
			<managing-box
				v-if="getParsedProductStats"
				title="통계"
				:is-block-box="true"
			>
				<div
					class="event-review__product-stats__item"
					v-for="(statsItem, idx) in getParsedProductStats"
					:key="idx"
				>
					<p class="event-review__product-stats__title">
						{{ statsItem.title }}
					</p>
					<div
						class="event-review__product-stats__event-type__item"
						v-for="(tableData, idx) in statsItem.list"
						:key="idx"
					>
						<p
							class="event-review__product-stats__event-type__title"
						>
							{{ tableData.title }}
						</p>
						<table
							class="table-main event-review__product-stats__table"
						>
							<thead>
								<tr>
									<th
										v-for="(th, idx) in tableData.thList"
										:key="idx"
									>
										{{ th }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(data, idx) in tableData.data"
									:key="idx"
								>
									<td v-if="data.item || data.item === 0">
										{{ data.item }}
									</td>
									<td v-if="data.avg || data.avg === 0">
										{{ data.avg }}
									</td>
									<td
										v-if="
											data.reviewCnt ||
											data.reviewCnt === 0
										"
									>
										{{ data.reviewCnt }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</managing-box>
		</managing-section>
		<managing-section :is-table="true">
			<table class="table-main event-review__table">
				<thead>
					<tr>
						<th v-for="th in reviewTableThList" :key="th">
							{{ th }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in reviewTable" :key="idx">
						<td>{{ idx + 1 }}</td>
						<td>{{ item.idRegister }}</td>
						<td>{{ item.nickname }}</td>
						<td>{{ item.isJoined ? '참여' : '' }}</td>
						<td>{{ item.isEvaluation ? '평가단' : '' }}</td>
						<td class="event-review__table__td--review">
							{{ item.reviewText }}
						</td>
						<td>{{ item.rating }}</td>
						<td>{{ item.likeCount }}</td>
						<td>{{ item.isDisplay ? '전시' : '' }}</td>
						<td class="white-space__nowrap">
							{{ item.create_date }}
						</td>
						<td>
							{{
								item.state === 'N'
									? '정상'
									: item.state === 'B'
										? '블라인드'
										: '검수중'
							}}
						</td>
						<td class="event-review__table__td--blind">
							{{ item.isBlind ? '블라인드' : '' }}
						</td>
						<td class="event-review__table__td--black">
							{{ item.isBlack ? '블랙' : '' }}
						</td>
						<td>{{ item.reviewCount }}</td>
						<td>
							<p
								v-for="(
									date, dateIdx
								) in item.lastReviewDates.map(
									item => item.split(' ')[0]
								)"
								:key="dateIdx"
							>
								{{ date }}
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
	</article>
</template>

<script>
	import util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'EventReview',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				minYear: 2019,
				yearFirstValue: '년',
				year: null,
				maxMonth: 12,
				monthFirstValue: '월',
				month: null,
				lastApiUrl: '',
				csvData: [],
				eventList: [],
				event: null,
				idAdminBoard: null,
				productFirstValue: { idProduct: null, productTitle: '선택' },
				idProduct: null,
				productOptionList: [
					{ id: 'rating', name: '평점' },
					{ id: 'ages', name: '연령' },
					{ id: 'skinType', name: '피부타입' },
				],
				eventTypeList: [
					{ id: 'All', name: '전체' },
					{ id: 'Eval', name: '평가단' },
				],
				ratingThList: ['평점', '리뷰수'],
				agesThList: ['연령대', '평점', '리뷰수'],
				skinTypeThList: ['피부타입', '평점', '리뷰수'],
				productStats: null,
				reviewTableThList: [
					'#',
					'유저항번',
					'닉네임',
					'이벤트 참여 여부',
					'평가단 여부',
					'리뷰',
					'평점',
					'좋아요',
					'전시여부',
					'작성일',
					'상태',
					'블라인드',
					'블랙리스트',
					'작성리뷰수',
					'최근 리뷰 작성일',
				],
				reviewTable: [],
			};
		},
		computed: {
			parsedEventList() {
				const idAdminBoard = this.idAdminBoard;
				if (idAdminBoard === null) return this.eventList;
				return this.eventList.map(item => {
					item.selected =
						item.originData.idAdminBoard === idAdminBoard;
					return item;
				});
			},
			hasEventList() {
				return this.eventList.length > 0;
			},
			yearList() {
				const yearList = [this.yearFirstValue];
				for (
					let year = new Date().getFullYear();
					this.minYear <= year;
					year--
				) {
					yearList.push(year);
				}
				return yearList;
			},
			monthList() {
				const monthList = [this.monthFirstValue];
				for (let month = 1; month <= this.maxMonth; month++) {
					monthList.push(month);
				}
				return monthList;
			},
			getProductList() {
				return this.event
					? [this.productFirstValue, ...this.event.products]
					: [this.productFirstValue];
			},
			getParsedProductStats() {
				if (!this.productStats) return null;
				return this.productOptionList.reduce(
					(productStats, productOption) => {
						const statsItem = {
							id: productOption.id,
							title: productOption.name,
							list: [],
						};
						this.eventTypeList.forEach(eventType => {
							const tableId = `${productOption.id}${eventType.id}`;
							const tableData = {
								id: tableId,
								title: eventType.name,
								thList: [],
								data: [],
							};
							const resData = this.productStats[tableId];
							tableData.thList =
								this[`${productOption.id}ThList`];
							const list = [];
							let avgSum = 0;
							let reviewCntSum = 0;
							let avgTotal = 0;
							let reviewCntTotal = 0;
							if (productOption.id === 'rating') {
								for (let key in resData) {
									const reviewCnt = Number(resData[key]);
									list.push({ item: key, reviewCnt });
									reviewCntSum += reviewCnt;
								}
								const length = list.length;
								list.push({
									item: '평균',
									reviewCnt: (reviewCntSum / length).toFixed(
										2
									),
								});
								list.push({
									item: '계',
									reviewCnt: reviewCntSum,
								});
							} else if (productOption.id === 'ages') {
								for (let key in resData) {
									const item = Number(key);
									const [avg, reviewCnt] = resData[key];
									avgSum += avg;
									reviewCntSum += reviewCnt;
									avgTotal += avg;
									reviewCntTotal += reviewCnt;
									if (item % 10 === 0 || item === -1) {
										list.push({
											item:
												item > 0
													? `${item}대`
													: `${40}대 이상`,
											avg: avgSum.toFixed(2),
											reviewCnt: reviewCntSum,
										});
										avgSum = 0;
										reviewCntSum = 0;
									}
								}
								const length = list.length;
								list.push({
									item: '평균/계',
									avg: (avgTotal / length).toFixed(2),
									reviewCnt: reviewCntTotal,
								});
							} else if (productOption.id === 'skinType') {
								for (let key in resData) {
									const item = Number(key);
									const [avg, reviewCnt] = resData[key];
									avgSum += avg;
									reviewCntSum += reviewCnt;
									list.push({
										item: this.$store.getters[
											'getItemById'
										]('skinType', item).name,
										avg: avg.toFixed(2),
										reviewCnt,
									});
								}
								const length = list.length;
								list.push({
									item: '평균/계',
									avg: (avgSum / length).toFixed(2),
									reviewCnt: reviewCntSum,
								});
							}
							tableData.data = list;
							statsItem.list.push(tableData);
						});
						productStats.push(statsItem);
						return productStats;
					},
					[]
				);
			},
		},
		watch: {
			'$route.query'(query) {
				this.setFilter(query);
			},
		},
		created() {
			this.setFilter(this.$route.query);
		},
		methods: {
			excelDown() {
				try {
					const rows = this.csvData.map(item => [
						item.idAdminBoard,
						item.boardTitle,
						item.brandTitle,
						item.productTitle,
						item.firstCategoryText,
						item.secondCategoryText,
						`${item.startDate} ~ ${item.endDate}`,
						item.evaluationCount,
						item.evaluationRating,
					]);
					const title = `평가단 이벤트(${this.year}년 ${this.month}월)`;
					util.getCsv(
						[rows],
						[title],
						[
							[
								'이벤트항번',
								'이벤트명',
								'브랜드',
								'평가단 진행 제품',
								'1차 카테고리',
								'2차 카테고리',
								'이벤트 기간',
								'평가단 리뷰수',
								'평가단 평점',
							],
						],
						`글로우픽_${title.replace(/ /g, '_')}`,
						this.lastApiUrl
					);
				} catch (err) {
					console.error(err);
					alert(
						'엑셀 파일을 다운로드하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async getEventList() {
				try {
					const { config, data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/events/year/${this.year}/month/${this.month}`
					);
					this.lastApiUrl = config.url;
					this.csvData = data.csvData;
					this.eventList = data.events.map(item => {
						return {
							title: `[${item.idAdminBoard}] ${item.boardTitle} (${item.products.length})`,
							period: `${item.startDate.split(' ')[0]} ~ ${item.endDate.split(' ')[0]}`,
							originData: item,
						};
					});
				} catch (err) {
					console.error(err);
					alert('이벤트 리스트를 불러오는데 실패했습니다.');
				}
			},
			async getProductData() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/analysis/reviews/event/${this.idAdminBoard}/${this.idProduct}?isNew=${this.event.isNew}`
					);
					this.productStats = data.stats;
					this.reviewTable = data.reviews;
				} catch (err) {
					console.error(err);
					alert('상품 데이터를 불러오는데 실패했습니다.');
				}
			},
			async setFilter(query) {
				this.year = query.year ? Number(query.year) : null;
				this.month = query.month ? Number(query.month) : null;
				this.idAdminBoard = null;
				this.event = null;
				this.idProduct = null;
				this.productStats = null;
				this.reviewTable = [];
				this.csvData = [];
				this.eventList = [];
				if (query.year && query.month) {
					await this.getEventList();
					if (query.idAdminBoard) {
						this.idAdminBoard = Number(query.idAdminBoard);
						this.event = this.eventList.filter(
							event =>
								event.originData.idAdminBoard ===
								Number(query.idAdminBoard)
						)[0].originData;
						if (query.idProduct) {
							this.idProduct = Number(query.idProduct);
							await this.getProductData();
						}
					}
				}
			},
			async searchEvent() {
				if (!this.year || !this.month) {
					alert('년/월 을 선택하세요.');
					return;
				}
				this.$router
					.replace({
						query: {
							year: this.year,
							month: this.month,
						},
					})
					.catch(() => {
						window.location.reload();
					});
			},
			selectEvent(idAdminBoard) {
				this.$router
					.replace({
						query: {
							year: this.year,
							month: this.month,
							idAdminBoard,
						},
					})
					.catch(() => {
						window.location.reload();
					});
			},
			changeProduct() {
				this.$router
					.replace({
						query: {
							year: this.year,
							month: this.month,
							idAdminBoard: this.idAdminBoard,
							idProduct: this.idProduct,
						},
					})
					.catch(() => {
						window.location.reload();
					});
			},
		},
	};
</script>

<style lang="scss">
	.event-review__search-event:after {
		content: '';
		display: block;
		clear: both;
	}

	.event-review .event-review__search-event__selector {
		float: left;
		display: block;
		margin-right: 4px;
	}

	.event-review .event-review__search-event-btn {
		float: left;
		display: block;
		margin-top: 3px;
		margin-right: 4px;
	}

	.event-review .event-review__event-excel-btn {
		float: right;
		display: block;
		margin-top: 3px;
	}

	.event-review__event-list {
		overflow-y: auto;
		height: 300px;
		margin-top: 8px;
		border: solid 1px #dfe6ee;
	}

	.event-review__event-list__btn {
		display: block;
		width: 100%;
		padding: 4px;
		text-align: left;

		&:hover {
			background: #f4f7fa;
		}

		&:active {
			background: lightsteelblue;
		}
	}

	.event-review__event-list__btn--selected {
		@extend .event-review__event-list__btn;

		background: lightgray;
	}

	.event-review__event-list__btn__title {
		display: block;
		line-height: 18px;
		margin-bottom: 4px;
		white-space: normal;
		word-break: break-all;
	}

	.event-review__event-list__btn__period {
		display: block;
		color: $btn-blue;
		white-space: normal;
		word-break: break-all;
	}

	.event-review__select-product__title {
		padding: 10px 0;
		line-height: 16px;
	}

	.event-review__product-stats__item {
		float: left;
		display: block;
		width: 33.33%;
		padding: 0 6px;

		&:first-child {
			padding: 0 12px 0 0;
		}

		&:last-child {
			padding: 0 0 0 12px;
		}
	}

	.event-review__product-stats__title {
		line-height: 24px;
		font-size: 1.375rem;
		font-weight: 700;
	}

	.event-review__product-stats__event-type__item {
		margin-top: 12px;
	}

	.event-review__product-stats__event-type__title {
		line-height: 20px;
		font-size: 1.125rem;
		margin-bottom: 8px;
	}

	.event-review .event-review__product-stats__table {
		height: 220px;

		th,
		td {
			height: auto;
			padding: 6px;
			text-align: left;
		}
	}

	.event-review__table {
		.event-review__table__td--review {
			text-align: left;
		}

		.event-review__table__td--blind {
			color: $red;
			font-weight: 700;
		}

		.event-review__table__td--black {
			font-weight: 700;
		}
	}
</style>
